import { useEffect } from 'react';
import { addSnack } from '../store';

export function addInfoSnack(msg, duration = 3000) {
  addSnack({ msg, variant: 'info', duration });
}

export function addSuccessSnack(msg, duration = 3000) {
  addSnack({ msg, variant: 'success', duration });
}

export function addErrorSnack(msg, duration = 3000) {
  addSnack({ msg, variant: 'error', duration });
}

export function useSuccessSnack(msg, signal, duration = 3000) {
  useEffect(() => {
    if (signal) addSuccessSnack(msg, duration);
  }, [signal, msg, duration]);
}

export function useErrorSnack(msg, signal, duration = 3000) {
  useEffect(() => {
    if (signal) addErrorSnack(msg, duration);
  }, [signal, msg, duration]);
}

export function useInfoSnack(msg, signal, duration) {
  useEffect(() => {
    if (signal) addInfoSnack(msg);
  }, [signal, msg, duration]);
}
